import { Pipe, PipeTransform } from "@angular/core";
import { ResourceService } from "../services/resource.service";

@Pipe({ name: 'DurationFormat' })
export class DurationFormatPipe implements PipeTransform {

    constructor(private resource: ResourceService) { }

    // value will be time duration in seconds
    // returned string will be 2 hours and 15 mins
    transform(value: number): string {
        let days: number = 0, hours: number = 0, minutes: number = 0;

        if (value > 0) {
            hours = Math.trunc(value / 3600);


            minutes = Math.trunc(value / 60) - hours * 60;

            if (minutes > 60) {
                minutes -= 60;
                hours++;
            }

            if (hours >= 24) {
                days = Math.trunc(hours / 24);
                hours = hours - (days * 24);

                if (hours > 0) {
                    return days + " " + this.resource.Localize("shared", "DF_Day") + " " + hours + " " + this.resource.Localize("shared", "DF_Hr");
                }
                else {
                    return days + " " + this.resource.Localize("shared", "DF_Day") + " " + minutes.toFixed(0) + " " + this.resource.Localize("shared", "DF_Min");
                }
            }


            if (hours != 0) {
                return hours + " " + this.resource.Localize("shared", "DF_Hr") + " " + minutes.toFixed(0) + " " + this.resource.Localize("shared", "DF_Min");
            }

            let seconds = value;

            if (value >= 60) {
                seconds = value - (minutes * 60);
            }

            return minutes + " " + this.resource.Localize("shared", "DF_Min") + " " + seconds.toFixed(0) + " " + this.resource.Localize("shared", "DF_Sec");
        }

        return "0 " + this.resource.Localize("shared", "DF_Min") + " 0 " + this.resource.Localize("shared", "DF_Sec");
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/pipes/duration-format.pipe.ts